/**
 * All available breakpoints.
 *
 * IMPORTANT! These numbers must match ./src/styles/breakpoints.styl and vice versa.
 */
export enum Breakpoint {
  SM = 768,
  MD = 992,
  LG = 1200,
  XL = 1500,
  XXL = 2000,
}

/**
 * Checks if width is within the breakpoint.
 * @param {number} width - In a Vue component you can use `this.$windowWidth` as `width`
 */
export function isWithinBP(width: number, breakpoint: Breakpoint): boolean {
  return width <= breakpoint;
}

/**
 * Checks if width is within the SM breakpoint.
 * @param {number} width - In a Vue component you can use `this.$windowWidth` as `width`
 */
export function isScreenSM(width: number): boolean {
  return isWithinBP(width, Breakpoint.SM);
}

/**
 * Checks if width is within the MD breakpoint.
 * @param {number} width - In a Vue component you can use `this.$windowWidth` as `width`
 */
export function isScreenMD(width: number): boolean {
  return isWithinBP(width, Breakpoint.MD);
}

/**
 * Checks if width is within the LG breakpoint.
 * @param {number} width - In a Vue component you can use `this.$windowWidth` as `width`
 */
export function isScreenLG(width: number): boolean {
  return isWithinBP(width, Breakpoint.LG);
}

/**
 * Checks if width is within the XL breakpoint.
 * @param {number} width - In a Vue component you can use `this.$windowWidth` as `width`
 */
export function isScreenXL(width: number): boolean {
  return isWithinBP(width, Breakpoint.XL);
}

/**
 * Checks if width is within the XXL breakpoint.
 * @param {number} width - In a Vue component you can use `this.$windowWidth` as `width`
 */
export function isScreenXXL(width: number): boolean {
  return isWithinBP(width, Breakpoint.XXL);
}

/**
 * Returns the current breakpoint the screen is in.
 * @param {number} width - In a Vue component you can use `this.$windowWidth` as `width`
 */
export function getCurrentBreakpoint(width: number): Breakpoint {
  const breakpoint = [
    Breakpoint.SM,
    Breakpoint.MD,
    Breakpoint.LG,
    Breakpoint.XL,
    Breakpoint.XXL,
  ].find((bp) => width <= bp);

  if (breakpoint) {
    return breakpoint;
  }

  return Breakpoint.LG;
}
